
import { Link } from "react-router-dom";
import ReactTimeAgo from "react-time-ago";


export default function Rule({rule, position}) {
    // states


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>{rule?.lib}</td>
            <td>{rule?.action}</td>
            <td>{rule.libparent ? rule?.libparent : ""}</td>
            <td>
                <div className={`badge mr-2 ${
                        (rule?.card <= 0) ? 'badge-warning' :
                        (rule?.card > 0) ? 'badge-success' :
                        ''
                        }`
                    }>
                        {rule?.etatdef}
                </div>
            </td>
            <td>{rule?.datecrea ? <ReactTimeAgo date={Date.parse(rule?.datecrea)} timeStyle="facebook" /> : ""}</td>
            <td className="text-center">
                <Link to={`/rule/${rule?.code}`} data-toggle="tooltip" title="consulter le droit" data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                    <i className="fa fa-eye"></i>
                </Link>
            </td>
        </tr>
    )
}